var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$company
    ? _c("div", { staticClass: "is-flex is-align-items-baseline" }, [
        _c("div", { staticClass: "is-size-4 has-text-weight-medium pr-1" }, [
          _vm._v(_vm._s(_vm.time)),
        ]),
        _c("div", { staticClass: "is-size-7 has-text-weight-semibold" }, [
          _vm.timeAmPm === "am"
            ? _c("span", { staticClass: "am-pm" }, [_vm._v("AM")])
            : _vm._e(),
          _vm.timeAmPm === "pm"
            ? _c("span", { staticClass: "am-pm" }, [_vm._v("PM")])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }